import { InviteStatus, InviteStatusId } from '../interfaces/IInviteStatus';

/** List row shape from stock-owners API (ADR-009). */
export type StockOwnerInviteRow = {
  status?: InviteStatus | string | null;
  isActive?: boolean;
  deletedAt?: string | null;
  statusId?: number;
};

/**
 * ADR-009: never show green "active" when stock row is inactive (API may lag).
 * Keeps "pending" when invitation not yet accepted.
 */
export function normalizeStockOwnerRowInviteStatus<T extends StockOwnerInviteRow>(row: T): T {
  if (!row) return row;
  if (row.deletedAt) {
    return { ...row, status: 'deactivated' as InviteStatus, statusId: InviteStatusId.DEACTIVATED };
  }
  const raw = (row.status as InviteStatus) || null;
  if (raw === 'active' && row.isActive === false) {
    return { ...row, status: 'deactivated' as InviteStatus, statusId: InviteStatusId.DEACTIVATED };
  }
  return row;
}

export function normalizeStockOwnerListInviteStatus<T extends StockOwnerInviteRow>(
  list: T[] | undefined,
): T[] {
  if (!list?.length) return list ?? [];
  return list.map((row) => normalizeStockOwnerRowInviteStatus(row));
}
